import "./ProductsAndServices.module.css";
import Header from "@/reusable_sections/Header";
import Solutions from "./sections/Solutions";
import CallToAction from "./sections/CallToAction";
import Footer from "@/reusable_sections/Footer";
export default function ProductsAndServicesPage() {
  return <div>
      <Header />
      <Solutions />
      <CallToAction />
      <Footer />
    </div>;
}